var _path, _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristmasHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.888 0.732783L11.8995 0.735843C14.666 1.47132 14.7857 1.94066 16.9536 3.65649C20.2062 6.23071 20.5263 7.90728 20.5263 7.90728L7.54759 13.1024C7.54759 13.1024 4.99141 4.77977 3.69267 7.90728C3.45946 8.46888 3.9903 9.26174 3.9903 9.86146C3.9903 14.4257 1.53812 17.8835 1.53812 17.8835C1.53812 17.8835 2.06865 14.997 1.0788 10.9942C0.262484 7.69319 -0.850969 6.58086 1.03267 3.65649C2.27429 1.72885 2.91541 1.28887 5.21736 0.477547C7.6728 -0.38787 9.36191 0.0611935 11.888 0.732783Z",
    fill: "#FF002B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5847 4.06249C20.5936 4.06273 21.4123 4.88936 21.4392 5.91893C21.8334 6.26883 22.0838 6.7852 22.0838 7.36229C22.0836 8.4159 21.2521 9.27036 20.2263 9.2705C20.0277 9.2705 19.8365 9.23701 19.657 9.17772C19.318 9.5509 18.8367 9.78604 18.3006 9.78612C18.0862 9.78612 17.8808 9.74634 17.6892 9.67772C17.3789 10.2865 16.7592 10.7031 16.0437 10.7031C15.7674 10.7031 15.506 10.6385 15.2703 10.5273C14.9607 11.0103 14.4448 11.3391 13.8504 11.3818C13.5145 11.8751 12.9584 12.1982 12.3279 12.1982C12.1178 12.1982 11.9166 12.1607 11.7283 12.0947C11.4549 12.7987 10.7866 13.2968 10.0037 13.2969C9.66997 13.2969 9.35737 13.2051 9.08669 13.0469C8.89445 13.8903 8.1598 14.5185 7.28005 14.5185C6.86807 14.5185 6.48847 14.3796 6.18044 14.1465C6.03136 14.1861 5.87576 14.2099 5.71462 14.2099C4.6886 14.2099 3.8572 13.3556 3.8572 12.3017C3.85722 11.4621 4.38529 10.7502 5.11892 10.4951C5.33766 9.69152 6.05388 9.10172 6.90603 9.10155C7.14303 9.10155 7.36949 9.14834 7.5779 9.23143C7.57509 9.18849 7.57205 9.14523 7.57204 9.10155C7.57204 8.04771 8.40442 7.19335 9.43044 7.19335C9.74963 7.1934 10.0499 7.27618 10.3123 7.42186C10.4303 6.48481 11.2087 5.76077 12.1531 5.76073C12.5965 5.76073 13.0036 5.92028 13.323 6.18651C13.4986 5.32029 14.246 4.66915 15.1414 4.66893C15.511 4.66893 15.8549 4.78152 16.1443 4.97264C16.4713 4.42719 17.057 4.06255 17.7263 4.06249C18.0648 4.06249 18.3817 4.15688 18.6551 4.31932C18.9285 4.15669 19.246 4.06249 19.5847 4.06249Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.99942,
    cy: 15.9753,
    rx: 1.85778,
    ry: 1.90814,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4707",
    x: 1.8572,
    y: 2.06249,
    width: 24.2266,
    height: 16.4561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.709804 0 0 0 0 0.447059 0 0 0 0 0.556863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4707",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasHat);
export default __webpack_public_path__ + "static/media/christmas-hat.6ccb8d7488a05b5ad7ae79db77c21963.svg";
export { ForwardRef as ReactComponent };